module.exports = __webpack_public_path__ + "static/img/SketchPngd073b8c2e98c998a14c6556b8d9450e1d8998d19c8c16a1caca393815f348f8d.ede38f97.png";